import sha256 from 'crypto-js/sha256';
import { FarmProduct } from 'public/context/CartContext';
export function createCartFingerprint(farmProducts: FarmProduct[]): string {
  type CanonItem = { id: number; qty: string; del: number | null };

  const canon: CanonItem[] = farmProducts
    .flatMap((fp) => fp.products)
    .filter((p) => p.requires_auth)
    .map((p) => ({
      id: p.cartProduct!.id,
      qty: Number(p.amount).toFixed(3),
      del: p?.cartProduct?.amount ?? null,
    }))
    .sort((a, b) => a.id - b.id);

  return sha256(JSON.stringify(canon)).toString();
}
